const FlightProviders = {
  KIWI: 1,
  GOFLYSMART: 2,
  AIRIQ: 3,
  TBO: 4,
};

export default FlightProviders;
